import axios from 'axios';
import { defineCancelApiObject } from './axiosUtils'; // optional if you use cancellation

const rapidAPIKey = '2af7e89762msh281958014a20b47p123dbcjsn303d109286b9';
const rapidAPIHost = 'local-business-data.p.rapidapi.com';

export const getLifeBusinesses = {
  async get(cancel = false) {
    const response = await axios.request({
      method: 'GET',
      url: 'https://local-business-data.p.rapidapi.com/search-in-area',
      params: {
        query: 'pizza', // You might want to make this dynamic later
        lat: '37.359428',
        lng: '-121.925337',
        zoom: '13',
        limit: '20',
        language: 'en',
        region: 'us',
        extract_emails_and_contacts: 'false',
      },
      headers: {
        'x-rapidapi-key': rapidAPIKey,
        'x-rapidapi-host': rapidAPIHost,
      },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return {
      results: response.data.data.map((business, index) => ({
        id: business.id || index,
        name: business.name,
        image_url:
          business.photos_sample?.[0]?.photo_url ||
          'https://via.placeholder.com/150',
        website: business.website || '',
        rating: business.rating || null,
        address: business.address || '',
        phone: business.phone_number || '',
      })),
    };
  },
};

export const getLifeBusinessById = {
  async get(id, cancel = false) {
    // In the real API you don't have a direct lookup by ID; we simulate it by filtering manually.
    const allBusinesses = await getLifeBusinesses.get(cancel);
    const business = allBusinesses.results.find((b) => b.id === id);

    if (!business) {
      throw new Error('Business not found');
    }

    return business;
  },
};

const cancelApiObject = defineCancelApiObject(getLifeBusinesses);
